import React from 'react';
import PropTypes from 'prop-types';

import {Box, Title, Stack, Divider, IconButton} from 'views/components';
import {DragIndicator, Close, Edit as EditIcon} from 'views/icons';

import constants from '../utils/constants';

const WidgetHeader = (props) => {
  const {
    title,
    actionItem,
    editMode,
    removeWidget,
    openSettings,
  } = props;

  return (
    <>
      <Box sx={{display: 'flex', justifyContent: 'space-between', height: '40px', mb: '4px'}}>
        <Title
          logo={
            editMode ?
              <DragIndicator sx={{height: 32, width: 32}} className={constants.DragHandleClassName}/>:
              null
          }
          disableDivider
          sx={{textTransform: 'uppercase', fontWeight: 600, display: 'inline-block'}}
        >
          {title}
        </Title>
        <Stack>
          {
              editMode ?
              <Stack direction="row" alignItems="center">
                {openSettings &&
                  <IconButton onClick={openSettings} sx={{p: 0.5}}>
                    <EditIcon/>
                  </IconButton>
                }
                <IconButton onClick={removeWidget} sx={{p: 0.5}}>
                  <Close />
                </IconButton>
              </Stack> :
              actionItem
          }
        </Stack>
      </Box>
      <Divider/>
    </>
  );
};

WidgetHeader.propTypes = {
  title: PropTypes.string.isRequired,
  actionItem: PropTypes.node,
  editMode: PropTypes.bool.isRequired,
  removeWidget: PropTypes.func.isRequired,
  openSettings: PropTypes.func,
};

export default React.memo(WidgetHeader);
